import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface RequestDetailsState {
  holidays?: string[];
}

const initialState: RequestDetailsState = {};

const requestDetailsSlice = createSlice({
  name: "requestDetails",
  initialState,
  reducers: {
    getHolidaysList(state, action: PayloadAction<string[]>) {
      state.holidays = action.payload;
    },
    destroy() {
      return initialState;
    }
  }
});

export default requestDetailsSlice.reducer;
export const { getHolidaysList, destroy } = requestDetailsSlice.actions;
export const requestDetailsActions = requestDetailsSlice.actions;
